import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import LegalDocument from '../../components/Legal/LegalDocument';
import { CGU_META, CGU_SECTIONS, CGU_ANNEXE } from '../../content/cguContent';
import '../../components/Legal/LegalDocument.css';

export default function CguPage() {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <header className="legal-page__header">
        <button type="button" className="legal-page__back" onClick={() => navigate(-1)}>
          <ArrowLeft size={18} strokeWidth={2.5} />
          Retour
        </button>
      </header>
      <div className="legal-page__content">
        <LegalDocument
          meta={CGU_META}
          sections={CGU_SECTIONS}
          annexe={CGU_ANNEXE}
          acceptance={{
            title: 'Acceptation',
            paragraphs: [
              'En cochant « J\'accepte les conditions générales d\'utilisation » et/ou en utilisant la Plateforme Shynea, vous reconnaissez avoir lu et accepté les présentes CGU, le rôle d\'intermédiaire de Shynea, les limitations de responsabilité, ainsi que les modalités d\'Acompte, Commission, escrow et remboursements.',
            ],
          }}
        />
      </div>
    </div>
  );
}
